import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  lifecycle,
  withHandlers
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Modal from '@material-ui/core/Modal';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import { TableRow } from '@material-ui/core';
import { Text } from 'recharts';
// import ShopTableBodyShop from '../../components/molecules/ShopTableBodyShop';
import ShopEditShop from './ShopEditShop';
import ShopDetailShop from './ShopDetailShop';
import DetailTextButton from '../../components/atoms/DetailTextButton';
import EditTextButton from '../../components/atoms/EditTextButton';
import CoppyButton from '../../components/atoms/CoppyButton';
// import TablePagination from '../../components/molecules/TablePagination';
import { getShopDetail } from '../../actions/Shop';
import { sendLogin } from '../../auth/Auth';
import {
  GET_BANK_BRANCH_LIST_SUCCESS,
  GET_BANK_LIST_SUCCESS,
  getBankList,
  getBankBranchList
} from '../../actions/Bank';

const styles = {
  root: {
    maxHeight: 375,
    // overflowX: 'scroll',
    whiteSpace: 'nowrap',
    width: '90%',
    margin: 'auto',
    paddingBottom: 10
  },
  shopHeader: {
    backgroundColor: '#717171 !important',
    height: 'auto',
    minHeight: 22,
    marginBottom: 10,
    display: 'flex',
    alignItems: 'center'
  },
  tableInfo: {
    width: '100%',
    marginBottom: 10
  },
  tableInfoCellHeader: {
    padding: '5px 10px',
    width: '60px',
    borderBottom: '2px solid #ffffff',
    fontSize: '12px',
    fontWeight: 'bold',
    color: '#000000',
    backgroundColor: '#F7F7F7',
    whiteSpace: 'nowrap'
  },
  tableInfoCell: {
    padding: '2px 10px',
    borderBottom: '2px solid transparent',
    fontSize: '12px',
    whiteSpace: 'break-spaces'
  },
  tableCellBorderNone: {
    borderBottom: 'none'
  },
  tableRowShopName: {
    paddingLeft: 16
  },
  titleGroupNameDiv: {
    padding: '5px 12px'
  },
  titleGroupName: {
    fontSize: 10,
    fontWeight: 'normal',
    lineHeight: '13px',
    color: 'rgba(255, 255, 255, 0.87)'
  },
  textGroupNameDiv: {
    padding: '5px 12px'
  },
  textGroupName: {
    fontSize: 12,
    lineHeight: '16px',
    color: '#fff',
    whiteSpace: 'break-spaces'
  },
  textShopId: {
    fontSize: 10,
    fontWeight: 'normal',
    lineHeight: '13px',
    color: 'rgba(0, 0, 0, 0.54)'
  },
  textShopName: {
    fontWeight: 'bold',
    fontSize: 16,
    lineHeight: '21px',
    color: 'rgba(0, 0, 0, 0.87)',
    marginBottom: 5,
    whiteSpace: 'break-spaces'
  },
  buttonDiv: {
    backgroundColor: '#F7F7F7',
    display: 'block',
    borderBottom: 'none',
    textAlign: 'center',
    marginBottom: 10,
    margin: 'auto'
  },
  modalMobile: {
    maxWidth: 380,
    margin: 'auto',
    padding: '5% 12px 5%'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      account: state.accounts.account,
      shops: state.shops.shops,
      totalCount: state.shops.totalCount,
      offset: state.shops.offset,
      accessibleShops: state.shops.accessibleShops,
      shopCategories: state.commons.shopCategories
    }),
    dispatch => ({
      actions: bindActionCreators(
        { getShopDetail, getBankList, getBankBranchList },
        dispatch
      )
    })
  ),
  setPropTypes(propTypes),
  withState('openDrawer', 'updateOpenDrawer', false),
  withState('openDetailModal', 'updateOpenDetailModal', false),
  withState('openEditModal', 'updateOpenEditModal', false),
  withState('openEditConfirm', 'updateOpenEditConfirm', false),
  withState('groupId', 'setGroupId', 0),
  withState('groupName', 'setGroupName', ''),
  withState('groupDepositManage', 'setGroupDepositManage', ''),
  withState('shopId', 'setShopId', 0),
  withState('shopName', 'setShopName', ''),
  withState('shopNameKana', 'setShopNameKana', ''),
  withState('countryCode', 'setCountryCode', ''),
  withState('zipCode', 'setZipCode', ''),
  withState('prefectureCode', 'setPrefectureCode', 0),
  withState('prefectures', 'setPrefectures', ''),
  withState('city', 'setCity', ''),
  withState('cityName', 'setCityName', ''),
  withState('cityId', 'setCityId', ''),
  withState('address', 'setAddress', ''),
  withState('address1', 'setAddress1', ''),
  withState('address2', 'setAddress2', ''),
  withState('cashAllowed', 'setCashAllowed', 0),
  withState('isShopCanEditSetting', 'setIsShopCanEditSetting', false),
  withState('shopDetail', 'setShopDetail', {}),
  withState('building', 'setBuilding', ''),
  withState('shopGroupName', 'setShopGroupName', ''),
  withState('shopContactName', 'setShopContactName', ''),
  withState('department', 'setDepartment', ''),
  withState('contactPhone', 'setContactPhone', ''),
  withState('phone', 'setPhone', ''),
  withState('introduction', 'setIntroduction', ''),
  withState('businessHours', 'setBusinessHours', ''),
  withState('holiday', 'setHoliday', ''),
  withState('nearestStation', 'setNearestStation', ''),
  withState('priceRange', 'setPriceRange', ''),
  withState('access', 'setAccess', ''),
  withState('webPage', 'setWebPage', ''),
  withState('tags', 'setTags', []),
  withState('tagStr', 'setTagStr', ''),
  withState('images', 'setImages', []),
  withState('shopAnniversaries', 'setShopAnniversaries', []),
  withState('status', 'setStatus', ''),
  withState('statusStr', 'setStatusStr', ''),
  withState('stealthMode', 'setStealthMode', ''),
  withState('stealthModeStr', 'setStealthModeStr', ''),
  withState('gochiRestriction', 'setGochiRestriction', ''),
  withState('gochiRestrictionStr', 'setGochiRestrictionStr', ''),
  withState('depositManage', 'setDepositManage', 'NONSELF'),
  withState('depositManageStr', 'setDepositManageStr', '入金を自身で管理する'),
  withState('bankName', 'setBankName', ''),
  withState('bankBranchName', 'setBankBranchName', ''),
  withState('bankAccountType', 'setBankAccountType', 'SAVINGS'),
  withState('bankAccountTypeStr', 'setBankAccountTypeStr', '普通預金'),
  withState('bankAccountNumber', 'setBankAccountNumber', ''),
  withState('bankAccountHolder', 'setBankAccountHolder', ''),
  withState('inviteUserId', 'setInviteUserId', 0),
  withState('inviteUserStr', 'setInviteUserStr', ''),
  withState('cognitoUserId', 'setCognitoUserId', ''),
  withState('email', 'setEmail', ''),
  withState('bankSwitchable', 'setBankSwitchable', true),
  withState('createdAt', 'setCreatedAt', ''),
  withState('updatedAt', 'setUpdatedAt', ''),
  withState('rowsPerPage', 'setRowsPerPage', 100),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', null),
  withState('shopCategoryId', 'setShopCategoryId', 0),
  withState('numberSit', 'setNumberSit', ''),
  withState('smoking', 'setSmoking', ''),
  withState('parking', 'setParking', ''),
  withState('snsFacebook', 'setSnsFacebook', ''),
  withState('snsTwitter', 'setSnsTwitter', ''),
  withState('snsInstagram', 'setSnsInstagram', ''),
  withState('page', 'setPage', 0),
  withState('showPhone', 'setShowPhone', 1),
  withState('childShopFlag', 'setChildShopFlag', 0),
  withState('accountStatus', 'setAccountStatus', 1),
  withState('statusShop', 'setStatusShop', 'AVAILABLE'),
  withState('message', 'setMessage', ''),
  withState('paymentGroupType', 'setPaymentGroupType', ''),
  withState('otherLanguages', 'setOtherLanguages', []),
  withState('bankCode', 'setBankCode', ''),
  withState('bankBranchCode', 'setBankBranchCode', ''),
  withState('listBank', 'setListBank', []),
  withState('listBankBranch', 'setListBankBranch', []),
  withState('registrationId', 'setRegistrationId', 'T'),
  withState('groupRegistrationId', 'setGroupRegistrationId', 'T'),
  withState('paymentGroupId', 'setPaymentGroupId', null),
  withState('allowGapPayment', 'setAllowGapPayment', 0),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeRowsPerPage: props => (event, rowsPerPage) => {
      props.setRowsPerPage(rowsPerPage);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {}
  })
);

const Main = enhance(
  ({
    account,
    classes,
    actions,
    checkSession,
    roles,
    progress,
    searchKey,
    shops,
    openDetailModal,
    updateOpenDetailModal,
    openEditModal,
    updateOpenEditModal,
    openEditConfirm,
    updateOpenEditConfirm,
    groupId,
    setGroupId,
    groupName,
    setGroupName,
    groupDepositManage,
    setGroupDepositManage,
    shopId,
    setShopId,
    shopName,
    setShopName,
    shopNameKana,
    setShopNameKana,
    countryCode,
    setCountryCode,
    zipCode,
    setZipCode,
    prefectureCode,
    setPrefectureCode,
    prefectures,
    setPrefectures,
    city,
    setCity,
    // cityName,
    // setCityName,
    // cityId,
    // setCityId,
    address,
    setAddress,
    building,
    setBuilding,
    shopGroupName,
    setShopGroupName,
    shopContactName,
    setShopContactName,
    department,
    setDepartment,
    contactPhone,
    setContactPhone,
    phone,
    setPhone,
    introduction,
    setIntroduction,
    businessHours,
    setBusinessHours,
    holiday,
    setHoliday,
    nearestStation,
    setNearestStation,
    priceRange,
    setPriceRange,
    access,
    setAccess,
    webPage,
    setWebPage,
    tags,
    setTags,
    tagStr,
    setTagStr,
    images,
    setImages,
    shopAnniversaries,
    setShopAnniversaries,
    status,
    setStatus,
    statusStr,
    setStatusStr,
    stealthMode,
    setStealthMode,
    stealthModeStr,
    setStealthModeStr,
    gochiRestriction,
    setGochiRestriction,
    gochiRestrictionStr,
    setGochiRestrictionStr,
    depositManage,
    setDepositManage,
    depositManageStr,
    setDepositManageStr,
    bankName,
    setBankName,
    bankBranchName,
    setBankBranchName,
    bankAccountType,
    setBankAccountType,
    bankAccountTypeStr,
    setBankAccountTypeStr,
    bankAccountNumber,
    setBankAccountNumber,
    bankAccountHolder,
    setBankAccountHolder,
    inviteUserId,
    setInviteUserId,
    inviteUserStr,
    setInviteUserStr,
    cognitoUserId,
    setCognitoUserId,
    email,
    setEmail,
    bankSwitchable,
    setBankSwitchable,
    createdAt,
    setCreatedAt,
    updatedAt,
    setUpdatedAt,
    shopCategories,
    shopCategoryId,
    setShopCategoryId,
    numberSit,
    setNumberSit,
    smoking,
    setSmoking,
    parking,
    setParking,
    snsFacebook,
    setSnsFacebook,
    setSnsTwitter,
    snsTwitter,
    setSnsInstagram,
    snsInstagram,
    showPhone,
    setShowPhone,
    childShopFlag,
    setChildShopFlag,
    accountStatus,
    setAccountStatus,
    paymentGroupType,
    setPaymentGroupType,
    address1,
    setAddress1,
    address2,
    setAddress2,
    handleChangePage,
    otherLanguages,
    setOtherLanguages,
    cashAllowed,
    setCashAllowed,
    shopDetail,
    setShopDetail,
    isShopCanEditSetting,
    setIsShopCanEditSetting,
    isFukuoka,
    bankCode,
    setBankCode,
    bankBranchCode,
    setBankBranchCode,
    listBank,
    setListBank,
    listBankBranch,
    setListBankBranch,
    isRegister = false,
    registrationId,
    setRegistrationId,
    groupRegistrationId,
    setGroupRegistrationId,
    paymentGroupId,
    setPaymentGroupId,
    educateSystem,
    allowGapPayment,
    setAllowGapPayment
  }) => {
    // const emptyRows =
    //   rowsPerPage - Math.min(rowsPerPage, totalCount - page * rowsPerPage);
    const detail = {
      otherLanguages,
      groupId,
      groupName,
      groupDepositManage,
      shopId,
      shopName,
      shopNameKana,
      countryCode,
      zipCode,
      prefectureCode,
      prefectures,
      city,
      // cityName,
      // cityId,
      address,
      address1,
      address2,
      building,
      shopGroupName,
      shopContactName,
      department,
      contactPhone,
      phone,
      businessHours,
      introduction,
      holiday,
      nearestStation,
      priceRange,
      access,
      webPage,
      tags,
      tagStr,
      images,
      shopAnniversaries,
      status,
      statusStr,
      stealthMode,
      stealthModeStr,
      gochiRestriction,
      gochiRestrictionStr,
      depositManage,
      depositManageStr,
      bankName,
      bankBranchName,
      bankAccountType,
      bankAccountTypeStr,
      bankAccountNumber,
      bankAccountHolder,
      inviteUserId,
      inviteUserStr,
      cognitoUserId,
      email,
      bankSwitchable,
      createdAt,
      updatedAt,
      shopCategories,
      shopCategoryId,
      numberSit,
      smoking,
      parking,
      snsFacebook,
      snsTwitter,
      snsInstagram,
      showPhone,
      childShopFlag,
      accountStatus,
      paymentGroupType,
      cashAllowed,
      shopDetail,
      isShopCanEditSetting,
      bankCode,
      bankBranchCode,
      registrationId,
      groupRegistrationId,
      paymentGroupId,
      allowGapPayment
    };

    const getShop = async id => {
      await actions.getShopDetail(id).then(detailData => {
        checkSession(detailData);
        setGroupId(detailData.payload.groupId);
        setGroupName(detailData.payload.groupName);
        setGroupDepositManage(detailData.payload.groupDepositManage);
        setShopId(detailData.payload.shopId);
        setShopName(detailData.payload.shopName);
        setShopNameKana(detailData.payload.shopNameKana);
        setCountryCode(detailData.payload.countryCode);
        setZipCode(detailData.payload.zipCode);
        setPrefectureCode(detailData.payload.prefectureCode);
        setPrefectures(detailData.payload.prefectures);
        setCity(detailData.payload.city);
        // setCityId(detailData.payload.cityId);
        // setCityName(detailData.payload.cityName);
        setAddress(detailData.payload.address);
        setAddress1(detailData.payload.address1);
        setAddress2(detailData.payload.address2);
        setAddress(detailData.payload.address);
        setBuilding(detailData.payload.building);
        setShopGroupName(detailData.payload.shopGroupName);
        setShopContactName(detailData.payload.shopContactName);
        setDepartment(detailData.payload.department);
        setContactPhone(detailData.payload.contactPhone);
        setPhone(detailData.payload.phone);
        setIntroduction(detailData.payload.introduction);
        setBusinessHours(detailData.payload.businessHours);
        setHoliday(detailData.payload.holiday);
        setNearestStation(detailData.payload.nearestStation);
        setPriceRange(detailData.payload.priceRange);
        setAccess(detailData.payload.access);
        setWebPage(detailData.payload.webPage);
        setShopCategoryId(detailData.payload.shopCategoryId);
        setNumberSit(detailData.payload.numberSit);
        setSmoking(detailData.payload.smoking);
        setParking(detailData.payload.parking);
        setSnsFacebook(detailData.payload.snsFacebook);
        setSnsTwitter(detailData.payload.snsTwitter);
        setSnsInstagram(detailData.payload.snsInstagram);
        setShowPhone(detailData.payload.showPhone);
        setChildShopFlag(detailData.payload.childShopFlag);
        setAccountStatus(detailData.payload.accountStatus);
        setPaymentGroupType(detailData.payload.paymentGroupType);
        setCashAllowed(detailData.payload.cashAllowed);
        setAllowGapPayment(detailData.payload.allowGapPayment);
        setIsShopCanEditSetting(detailData.payload.isShopCanEditSetting);
        setShopDetail(detailData.payload.shopDetail);
        if (
          typeof detailData.payload.tags !== 'undefined' &&
          detailData.payload.tags !== null
        ) {
          setTags(detailData.payload.tags);
          setTagStr(
            detailData.payload.tags
              .map(tag => {
                return `${tag.tagName}`;
              })
              .join(' ')
          );
        }
        if (
          typeof detailData.payload.images !== 'undefined' &&
          detailData.payload.images !== null
        ) {
          setImages(detailData.payload.images);
        }
        if (
          typeof detailData.payload.shopAnniversaries !== 'undefined' &&
          detailData.payload.shopAnniversaries !== null
        ) {
          setShopAnniversaries(detailData.payload.shopAnniversaries);
        }
        setStatus(detailData.payload.status);
        setStatusStr(detailData.payload.statusStr);
        setStealthMode(detailData.payload.stealthMode);
        setStealthModeStr(detailData.payload.stealthModeStr);
        setGochiRestriction(detailData.payload.gochiRestriction);
        setGochiRestrictionStr(detailData.payload.gochiRestrictionStr);
        setDepositManage(detailData.payload.depositManage);
        setDepositManageStr(detailData.payload.depositManageStr);
        if (
          typeof detailData.payload.bankAccount !== 'undefined' &&
          detailData.payload.bankAccount !== null
        ) {
          setBankName(detailData.payload.bankAccount.bankName);
          setBankBranchName(detailData.payload.bankAccount.bankBranchName);
          setBankAccountType(detailData.payload.bankAccount.bankAccountType);
          setBankAccountTypeStr(
            detailData.payload.bankAccount.bankAccountTypeStr
          );
          setBankAccountNumber(
            detailData.payload.bankAccount.bankAccountNumber
          );
          setBankAccountHolder(
            detailData.payload.bankAccount.bankAccountHolder
          );
        }
        setInviteUserId(detailData.payload.inviteUserId);
        setInviteUserStr(detailData.payload.inviteUserStr);
        setCognitoUserId(detailData.payload.cognitoUserId);
        setEmail(detailData.payload.email);
        setBankSwitchable(detailData.payload.bankSwitchable);
        setCreatedAt(detailData.payload.createdAt);
        setUpdatedAt(detailData.payload.updatedAt);
        setOtherLanguages(detailData.payload.otherLanguages);
        setBankCode(detailData.payload.bankAccount.bankCode);
        setBankBranchCode(detailData.payload.bankAccount.bankBranchCode);
        setRegistrationId(detailData.payload.registrationId);
        setGroupRegistrationId(detailData.payload.groupRegistrationId);
        setPaymentGroupId(detailData.payload.paymentGroupId);
      });
    };

    const detailOpenAction = () => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      getShop(account.shopId)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenDetailModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };
    const editOpenAction = async () => {
      progress.updateLoading(true);
      progress.updateOpenProgress(true);
      const bankResponse = await actions
        .getBankList()
        .then(data => checkSession(data));
      if (bankResponse.type === GET_BANK_LIST_SUCCESS) {
        setListBank(bankResponse.payload);
      } else {
        setListBank([]);
      }
      const bankBranchResponse = await actions
        .getBankBranchList()
        .then(data => checkSession(data));
      if (bankBranchResponse.type === GET_BANK_BRANCH_LIST_SUCCESS) {
        setListBankBranch(bankBranchResponse.payload);
      } else {
        setListBankBranch([]);
      }
      await getShop(account.shopId)
        .then(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
          updateOpenEditModal(true);
        })
        .catch(() => {
          progress.updateOpenProgress(false);
          progress.updateLoading(false);
        });
    };

    return (
      <>
        <div className={classes.root} id="scrollTableId">
          {shops.map(shop => {
            return (
              <>
                <div className={classes.shopHeader}>
                  <div className={classes.titleGroupNameDiv}>
                    <Text className={classes.titleGroupName}>グループ名</Text>
                  </div>
                  <div className={classes.textGroupNameDiv}>
                    <Text className={classes.textGroupName}>
                      {shop.groupName}
                    </Text>
                  </div>
                </div>
                <Typography className={classes.textShopId}>
                  {`${isFukuoka ? '教室ID: ' : '店舗ID: '}`}
                  {shop.shopId}
                </Typography>
                <Typography className={classes.textShopName}>
                  {shop.shopName}
                </Typography>
                <Table className={classes.tableInfo}>
                  <TableBody>
                    <TableRow>
                      <TableCell className={classes.tableInfoCellHeader}>
                        住所
                      </TableCell>
                      <TableCell className={classes.tableInfoCell}>
                        {shop.prefectures}
                        {` `}
                        {shop.city}
                        {` `}
                        {shop.address1}
                        {` `}
                        {shop.address2}
                        {` `}
                        {shop.building}
                      </TableCell>
                    </TableRow>
                    <TableRow>
                      <TableCell className={classes.tableInfoCellHeader}>
                        {isFukuoka ? (
                          <>
                            教室電話
                            <br />
                            番号
                          </>
                        ) : (
                          '電話番号'
                        )}
                      </TableCell>
                      <TableCell className={classes.tableInfoCell}>
                        {shop.phone}
                      </TableCell>
                    </TableRow>
                    {!(isRegister || isFukuoka) && ( // hide if register shop
                      <TableRow>
                        <TableCell className={classes.tableInfoCellHeader}>
                          店舗ページ
                        </TableCell>
                        <TableCell className={classes.tableInfoCell}>
                          <CoppyButton
                            linkToCopy={`https://gochi.online/shopdetails/${
                              shop.shopId
                            }`}
                          />
                        </TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </>
            );
          })}
          <div className={classes.buttonDiv}>
            <DetailTextButton onClickAction={detailOpenAction} />
            <EditTextButton onClickAction={editOpenAction} />
          </div>
        </div>
        <Modal
          open={openDetailModal}
          onClose={() => {
            updateOpenDetailModal(false);
          }}
          className={classes.modalMobile}
        >
          <ShopDetailShop
            updateOpenDetailModal={updateOpenDetailModal}
            detail={detail}
            roles={roles}
            isFukuoka={isFukuoka}
          />
        </Modal>
        <Modal open={openEditModal} className={classes.modalMobile}>
          <ShopEditShop
            updateOpenEditModal={updateOpenEditModal}
            openEditConfirm={openEditConfirm}
            updateOpenEditConfirm={updateOpenEditConfirm}
            roles={roles}
            editInput={detail}
            searchKey={searchKey}
            handleChangePage={handleChangePage}
            isFukuoka={isFukuoka}
            listBank={listBank}
            listBankBranch={listBankBranch}
            educateSystem={educateSystem}
          />
        </Modal>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
